var map = {
	"./2.png": 7514,
	"./4.png": 5649,
	"./android.png": 9825,
	"./bag.png": 1755,
	"./companyNtrBg.png": 1000,
	"./companyProduct.png": 5362,
	"./contactUsBg.png": 6318,
	"./culture/afternoonTea/0.png": 8189,
	"./culture/afternoonTea/1.png": 8748,
	"./culture/afternoonTea/2.png": 3925,
	"./culture/afternoonTea/3.png": 2950,
	"./culture/afternoonTea/4.png": 7445,
	"./culture/afternoonTea/5.png": 8959,
	"./culture/afternoonTea/6.png": 6842,
	"./culture/birthday/0.png": 539,
	"./culture/birthday/1.png": 2601,
	"./culture/birthday/2.png": 671,
	"./culture/birthday/3.png": 1818,
	"./culture/birthday/4.png": 9961,
	"./culture/birthday/5.png": 2561,
	"./culture/birthday/6.png": 3831,
	"./culture/birthday/7.png": 1216,
	"./culture/club/1.png": 4975,
	"./culture/club/2.png": 4315,
	"./culture/club/3.png": 9186,
	"./culture/club/4.png": 1557,
	"./culture/club/5.png": 3424,
	"./culture/club/6.png": 6551,
	"./culture/club/7.png": 1161,
	"./culture/club/8.png": 5199,
	"./culture/club/9.png": 7175,
	"./culture/festival/1.png": 875,
	"./culture/festival/2.png": 6907,
	"./culture/festival/3.png": 5895,
	"./culture/festival/4.png": 4755,
	"./culture/festival/5.png": 7265,
	"./culture/festival/6.png": 4550,
	"./culture/life/1.png": 2773,
	"./culture/life/10.png": 5932,
	"./culture/life/11.png": 5144,
	"./culture/life/12.png": 8659,
	"./culture/life/13.png": 7750,
	"./culture/life/14.png": 7477,
	"./culture/life/15.png": 3563,
	"./culture/life/16.png": 8911,
	"./culture/life/2.png": 7725,
	"./culture/life/3.png": 3476,
	"./culture/life/4.png": 2949,
	"./culture/life/5.png": 9148,
	"./culture/life/6.png": 4797,
	"./culture/life/7.png": 5517,
	"./culture/life/8.png": 8487,
	"./culture/life/9.png": 7985,
	"./culture/mainImg1.png": 5098,
	"./culture/mainImg2.png": 6997,
	"./culture/mainImg3.png": 8017,
	"./culture/mainImg4.png": 25,
	"./culture/sub1.png": 4385,
	"./culture/sub2.png": 9926,
	"./culture/sub3.png": 1192,
	"./culture/sub4.png": 4234,
	"./culture/tourism/1.png": 3313,
	"./culture/tourism/2.png": 8621,
	"./culture/tourism/3.png": 8814,
	"./culture/tourism/4.png": 5711,
	"./culture/tourism/5.png": 8321,
	"./culture/tourism/6.png": 2419,
	"./culture/tourism/7.png": 7436,
	"./culture/tourism/8.png": 6834,
	"./gps.png": 2733,
	"./growthProcess.png": 3532,
	"./icon1.png": 2718,
	"./icon10.png": 1028,
	"./icon2.png": 6319,
	"./icon3.png": 4232,
	"./icon4.png": 4905,
	"./icon5.png": 7034,
	"./icon6.png": 7918,
	"./icon7.png": 9716,
	"./icon8.png": 8690,
	"./icon9.png": 7130,
	"./ios.png": 185,
	"./joinUsBanner.png": 9075,
	"./line2.png": 7259,
	"./line3.png": 4429,
	"./line4.png": 2430,
	"./logo.png": 5080,
	"./navBg.png": 4976,
	"./ntr01.png": 1260,
	"./ntr02.png": 4419,
	"./ntr03.png": 2020,
	"./ntr04.png": 295,
	"./ntr05.png": 5479,
	"./swiper-left-light.png": 4751,
	"./swiper-left.png": 8169,
	"./swiper-right-light.png": 5352,
	"./swiper-right.png": 4006,
	"./userTitle.png": 6737,
	"./welfareContent.png": 5549,
	"./图片 (3).png": 4398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4548;